<template>
    <li class="flex items-center justify-between gap-x-6 py-5">
        <div class="min-w-0">
            <div class="flex items-start gap-x-3">
                <p class="text-sm font-semibold leading-6 text-gray-900">{{ sale.name }}</p>
            </div>
            <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                <div class="flex items-center truncate">{{ sale.sale_type?.name }}</div>
                <svg viewBox="0 0 2 2" class="h-0.5 w-0.5 fill-current">
                    <circle cx="1" cy="1" r="1" />
                </svg>
                <p class="whitespace-nowrap">{{ moment(sale.starts_at_date).format(CONFIG.dates.formats.full_date) }}</p>
            </div>
        </div>
        <div class="flex flex-none items-center gap-x-4">
            <button v-on:click="addAssetToSale" class="rounded bg-blue-50 px-2 py-1 text-sm font-semibold text-blue-600 shadow-sm hover:bg-blue-100">Add to sale</button>
        </div>
    </li>
</template>

<script>
import {onMounted, reactive, watch} from 'vue'
import { useSystemStore } from '@sto/system.store'
import { useSaleStore } from '@sto/sale.store'
import moment from 'moment'
import CONFIG from '@lib/config'
export default {
    props: ['asset_id', 'sale', 'refresh'],
	setup(props, {emit}) {
        const SYSTEM_STORE = useSystemStore()
        const SALE_STORE = useSaleStore()

        const state = reactive({
            asset_loading: false
        })

    	/**
         * add this asset to the sale
         */
        const addAssetToSale = async () => {

            if (state.asset_loading) return

            state.asset_loading = true
            try {

                const lot = await SALE_STORE.addLotToAuctioneerSale(
                    props.sale.auctioneer_id,
                    props.sale.id,
                    { asset_id: props.asset_id }
                )
                emit('added', props.sale)
                if (props.refresh) props.refresh()
                SYSTEM_STORE.addSuccess('Success', 'The asset was added to the sale')
            } catch (error) {
                console.error('SALE_STORE.addLotToAuctioneerSale error', error)
                SYSTEM_STORE.addError('Error', error?.messag || 'There was an error adding this lot to the sale')

            } finally {
                state.asset_loading = false
            }
        }

        return {
            CONFIG,
            state,
            moment,
            addAssetToSale
        }
    }
}
</script>